/* EarthBased add-to-cart safety net - 10 Aug 2026 (v9)

   WHY THIS EXISTS
   The Interakt SDK is injected twice on the storefront (two shop-level
   ScriptTags). When its copy wins the load race it binds a click listener on
   Add To Cart, calls preventDefault(), then fails - so the theme's own handler
   never runs and nothing is added. This happens intermittently, not always.

   HOW THIS WORKS (safety net, not a takeover)
   It does NOT preventDefault. The theme's normal add-to-cart runs first, drawer
   and all. We snapshot the cart item count on click, wait CHECK_AFTER_MS, and
   only if the count has not changed do we add the item ourselves and show a
   confirmation toast. In the normal case this code does nothing visible.

   INTERACTION WITH THE PINCODE GATE - IMPORTANT
   eb-pincode.js sets window.EB_PINCODE_LOCKED = true while a restricted-vendor
   product is awaiting a serviceable pincode. Without the checks below, this
   script sees the blocked click as "nothing was added" and adds the product
   anyway - defeating the gate and showing a false confirmation toast.
   The two scripts cannot resolve this through the DOM event alone, because this
   script registers its listener FIRST and therefore runs before the gate's
   stopImmediatePropagation() can take effect. Hence the shared flag.

   SCOPE - READ BEFORE EDITING
   Only ever acts on the theme's Add To Cart button. The Shiprocket BUY NOW
   (fastrr) button lives inside the SAME form[action=/cart/add], so matching is
   an explicit allow-list plus a hard deny list. Do not widen the allow-list.

   OTHER GOTCHAS ON THIS STORE
   - window.fetch, XMLHttpRequest and HTMLFormElement.prototype.submit are ALL
     monkey-patched by installed apps. Do not rely on form.submit().
   - Do NOT put a /checkout link in the toast - Shiprocket rewrites checkout
     links and injects its widget into them. Link to /cart only.

   DELETE THIS FILE once Interakt removes its duplicate ScriptTag. */
(function(){
  'use strict';

  var CHECK_AFTER_MS = 1800;
  var ALLOW = '.add-to-cart-button, button[name="add"], input[name="add"]';
  var DENY  = '[class*="fastrr"], [id*="fastrr"], [class*="shiprocket"], [id*="shiprocket"], [class*="pickrr"], [id*="pickrr"], [class*="buy-now"], [id*="buy-now"], [class*="buynow"], [data-shopify="payment-button"], .shopify-payment-button';
  var busy = false;
  var toastEl = null, toastTimer = null;

  function gateLocked(){ return window.EB_PINCODE_LOCKED === true; }

  function denied(el){
    if(!el) return false;
    if(el.closest && el.closest(DENY)) return true;
    return (el.textContent || '').trim().toLowerCase().indexOf('buy now') > -1;
  }

  function cartCount(){
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){ return c && typeof c.item_count === 'number' ? c.item_count : null; })
      .catch(function(){ return null; });
  }

  function ensureToast(){
    if(toastEl) return toastEl;
    var t = document.createElement('div');
    t.setAttribute('role','status');
    t.style.cssText = 'position:fixed;z-index:2147483000;right:16px;bottom:86px;max-width:320px;background:#fff;color:#253d4e;border:1px solid #d8f1e5;border-radius:10px;box-shadow:0 8px 28px rgba(0,0,0,.16);padding:14px 16px;font-size:14px;line-height:1.4;opacity:0;transform:translateY(10px);transition:opacity .22s ease,transform .22s ease';
    (document.body || document.documentElement).appendChild(t);
    toastEl = t;
    return t;
  }

  function showToast(title){
    var t = ensureToast();
    t.innerHTML = '';
    var row = document.createElement('div');
    row.style.cssText = 'display:flex;align-items:flex-start;gap:10px';
    var tick = document.createElement('span');
    tick.textContent = '\u2713';
    tick.style.cssText = 'flex:0 0 20px;width:20px;height:20px;border-radius:50%;background:#4a8e5a;color:#fff;font-size:13px;line-height:20px;text-align:center';
    var col = document.createElement('div');
    col.style.cssText = 'flex:1 1 auto;min-width:0';
    var head = document.createElement('strong');
    head.textContent = 'Added to cart';
    head.style.cssText = 'display:block;margin-bottom:2px';
    var name = document.createElement('span');
    name.textContent = title || 'Item';
    name.style.cssText = 'display:block;color:#5b6b73;overflow:hidden;text-overflow:ellipsis;white-space:nowrap';
    var actions = document.createElement('span');
    actions.style.cssText = 'display:block;margin-top:10px';
    var view = document.createElement('a');
    view.href = '/cart';
    view.textContent = 'View cart';
    view.style.cssText = 'display:inline-block;padding:7px 14px;background:#4a8e5a;color:#fff;border-radius:6px;text-decoration:none;font-size:13px';
    var keep = document.createElement('button');
    keep.type = 'button';
    keep.textContent = 'Keep shopping';
    keep.style.cssText = 'display:inline-block;margin-left:8px;padding:7px 12px;border:1px solid #d8f1e5;background:#fff;color:#4a8e5a;border-radius:6px;font-size:13px;cursor:pointer';
    keep.addEventListener('click', function(){ t.style.opacity='0'; t.style.transform='translateY(10px)'; });
    actions.appendChild(view); actions.appendChild(keep);
    col.appendChild(head); col.appendChild(name); col.appendChild(actions);
    row.appendChild(tick); row.appendChild(col);
    t.appendChild(row);
    requestAnimationFrame(function(){ t.style.opacity='1'; t.style.transform='translateY(0)'; });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ t.style.opacity='0'; t.style.transform='translateY(10px)'; }, 6000);
  }

  function refreshCartCount(){
    fetch('/?sections=cart-count', { credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(json){
        var raw = json && json['cart-count'];
        if(!raw) return;
        var count = String(raw).replace(/<[^>]*>/g, '').trim();
        if(!count) return;
        var nodes = document.querySelectorAll('.cart-count, [data-cart-count], .cart-number, .header-icons .cart .count');
        Array.prototype.forEach.call(nodes, function(el){ el.textContent = count; });
      }).catch(function(){});
  }

  function payloadFrom(form){
    var id = form.querySelector('[name="id"]');
    if(!id || !id.value) return null;
    var qtyEl = form.querySelector('[name="quantity"]');
    var qty = qtyEl && parseInt(qtyEl.value, 10) > 0 ? parseInt(qtyEl.value, 10) : 1;
    var data = { id: id.value, quantity: qty };
    var props = {}, hasProps = false;
    Array.prototype.forEach.call(form.querySelectorAll('[name^="properties["]'), function(el){
      if(el.type === 'checkbox' && !el.checked) return;
      var key = el.name.slice(el.name.indexOf('[') + 1, el.name.lastIndexOf(']'));
      if(el.value){ props[key] = el.value; hasProps = true; }
    });
    if(hasProps) data.properties = props;
    return data;
  }

  function onClick(e){
    if(busy) return;
    if(gateLocked()) return;
    var target = e.target;
    if(!target || !target.closest || denied(target)) return;
    var btn = target.closest(ALLOW);
    if(!btn || denied(btn)) return;
    var form = btn.closest('form[action*="/cart/add"]');
    if(!form) return;

    var data = payloadFrom(form);
    if(!data) return;

    busy = true;

    cartCount().then(function(before){
      setTimeout(function(){
        if(gateLocked()){ busy = false; return; }
        cartCount().then(function(after){
          if(before === null || after === null || after !== before){ busy = false; return; }
          if(gateLocked()){ busy = false; return; }
          fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(data)
          }).then(function(res){
            if(!res.ok) throw new Error('add failed');
            return res.json();
          }).then(function(item){
            showToast(item && (item.product_title || item.title));
            refreshCartCount();
            busy = false;
          }).catch(function(){
            busy = false;
            window.location.href = '/cart';
          });
        });
      }, CHECK_AFTER_MS);
    });
  }

  document.addEventListener('click', onClick, true);
})();
